(function (angular) {
    'use strict';

    angular
        .module('app.grievance')
        .service('app.grievance.grievanceService', [
            "$http",
            grievanceService
        ]);

    function grievanceService($http) {
        return {
            submitGrievanceForm: submitGrievanceForm
        }

        function submitGrievanceForm(grievanceInfo) {
            return $http.post(environment.salesApiUrl + 'services/send-grievance-email', grievanceInfo);
        }
    }
    
})(angular);
